'use strict';
import * as $j_app$002eapi$002e$002dDrug$002dRequests$002dAccepted$002dList$002dItem$0024$002dProvided$002dE$002dP$002dS$002dCode$0024$002dAborted$0024 from "./app.api.-Drug-Requests-Accepted-List-Item$-Provided-E-P-S-Code$-Aborted$.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$13(SealedTraitDerivation_this$8) {
  this.Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$13__f_SealedTraitDerivation_this$2 = null;
  this.Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$13__f_SealedTraitDerivation_this$2 = SealedTraitDerivation_this$8;
}
export { $c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$13 as $c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$13 };
$c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$13.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$13.prototype.constructor = $c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$13;
/** @constructor */
function $h_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$13() {
}
export { $h_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$13 as $h_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$13 };
$h_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$13.prototype = $c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$13.prototype;
$c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$13.prototype.toString__T = (function() {
  return "<function0>";
});
$c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$13.prototype.apply__Lsttp_tapir_Schema = (function() {
  var Derivation_this = this.Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$13__f_SealedTraitDerivation_this$2;
  var m$proxy3 = $j_app$002eapi$002e$002dDrug$002dRequests$002dAccepted$002dList$002dItem$0024$002dProvided$002dE$002dP$002dS$002dCode$0024$002dAborted$0024.$m_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$Aborted$();
  var this$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var factory = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$();
  var factory$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_MapFactory$ToFactory(factory);
  factory$1.fromSpecific__sc_IterableOnce__O(this$2);
  var this$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var factory$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$();
  var factory$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_MapFactory$ToFactory(factory$2);
  factory$3.fromSpecific__sc_IterableOnce__O(this$4);
  var this$6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var factory$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$();
  var factory$5 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_MapFactory$ToFactory(factory$4);
  factory$5.fromSpecific__sc_IterableOnce__O(this$6);
  var this$8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var factory$6 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$();
  var factory$7 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_MapFactory$ToFactory(factory$6);
  factory$7.fromSpecific__sc_IterableOnce__O(this$8);
  var this$10 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var factory$8 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Map$();
  var factory$9 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sc_MapFactory$ToFactory(factory$8);
  factory$9.fromSpecific__sc_IterableOnce__O(this$10);
  var xs = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var len = xs.length__I();
  var array = new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lmagnolia1_CaseClass$Param.getArrayOf().constr)(len);
  var iterator = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  var i = 0;
  while (iterator.hasNext__Z()) {
    array.u[i] = iterator.next__O();
    i = ((1 + i) | 0);
  }
  var typeParams = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var $x_1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lmagnolia1_TypeInfo("app.api.DrugRequestsAcceptedListItem.ProvidedEPSCode", "Aborted", typeParams);
  var xs$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var len$1 = xs$1.length__I();
  var array$1 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(len$1);
  var iterator$1 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  var i$1 = 0;
  while (iterator$1.hasNext__Z()) {
    array$1.u[i$1] = iterator$1.next__O();
    i$1 = ((1 + i$1) | 0);
  }
  var xs$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var len$2 = xs$2.length__I();
  var array$2 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(len$2);
  var iterator$2 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  var i$2 = 0;
  while (iterator$2.hasNext__Z()) {
    array$2.u[i$2] = iterator$2.next__O();
    i$2 = ((1 + i$2) | 0);
  }
  var xs$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sci_Nil$();
  var len$3 = xs$3.length__I();
  var array$3 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ac_O(len$3);
  var iterator$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sc_Iterator$().sc_Iterator$__f_scala$collection$Iterator$$_empty;
  var i$3 = 0;
  while (iterator$3.hasNext__Z()) {
    array$3.u[i$3] = iterator$3.next__O();
    i$3 = ((1 + i$3) | 0);
  }
  return Derivation_this.join__Lmagnolia1_CaseClass__Lsttp_tapir_Schema(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lmagnolia1_CaseClassDerivation$ProductCaseClass($x_1, true, false, array, array$1, array$2, array$3, m$proxy3));
});
$c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$13.prototype.apply__O = (function() {
  return this.apply__Lsttp_tapir_Schema();
});
var $d_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$13 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$13, "app.api.DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$13", ({
  Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$13: 1,
  F0: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction0: 1
}));
export { $d_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$13 as $d_Lapp_api_DrugRequestsAcceptedListItem$ProvidedEPSCode$$anon$13 };
//# sourceMappingURL=app.api.-Drug-Requests-Accepted-List-Item$-Provided-E-P-S-Code$$anon$13.js.map
